module.exports = {
      id: "icon-play-usage",
      viewBox: "0 0 17.037 21.916",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }